export default function err404() {
    const style = {
        background: 'black',
        fontSize: '3em',
        color: "green",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
    }
  return (
    <div style={style}>error404 page not found.</div>
  )
}
